import { render } from "./SofiaChat.vue?vue&type=template&id=768537d3&scoped=true"
import script from "./SofiaChat.vue?vue&type=script&lang=js"
export * from "./SofiaChat.vue?vue&type=script&lang=js"

import "./SofiaChat.vue?vue&type=style&index=0&id=768537d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768537d3"]])

export default __exports__